// extracted by mini-css-extract-plugin
export default {"checkboxParent":"CheckBox_checkboxParent__LpV08","checkbox":"CheckBox_checkbox__lkuIJ","label":"CheckBox_label__Ljb0v"};